import { ROLE_NAME } from '@shootsta/common-domain-data';

export default function isShootstaEditorRoleName(roleName, status) {
  return ROLE_NAME.SHOOTSTA_EDITOR === roleName && status === 'ACCEPTED';
}